import React, { useState, useEffect, Suspense } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import { getApi } from '../../../Services/apiService';
import EditUserModal from './editUser';
import DeleteModal from './deleteUser';
import SubscriptionDetailModal from './subscriptionDetailModal';
import ViewUser from './viewUser';
import DeactivateModal from './deactivateModal';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Papa from 'papaparse';

const UserManagement = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const location = useLocation();
  const userId = location.state?.userId;
  const [filterQuery, setFilterQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [viewUserModal, setViewUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  // const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const handleSortDate = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  
    // Sort users array
    const sortedUsers = [...users].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  
    setUsers(sortedUsers);
  };
  
  const fetchUsers = async () => {
    if (query == '') {
      setLoading(true);
    }
    setError(null);

    try {
      const response = await getApi(`/admin/users?search=${query}`);

      if (response && response.status === 200) {
        setUsers(response?.data || []);
      } else {
        throw new Error('Failed to fetch users.');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [query]);

  useEffect(() => {
    if (!editUserModal && !deleteModal && !viewUserModal && !deactivateModal) {
      fetchUsers();
    }
  }, [editUserModal, deleteModal, viewUserModal, deactivateModal]);

  const handleSearchChange = (event) => {
    setQuery(event.target.value);
  };

  const openModal = (selectedUser) => {
    setSelectedUserId(selectedUser);
    setEditUserModal(true);
  };

  const openViewModal = (selectedUser) => {
    setSelectedUserId(selectedUser);
    setViewUserModal(true);
  };

  const openDeleteUserModal = (user) => {
    setSelectedUserId(user);
    setDeleteModal(true);
  };

  

  const formatDate = (timestamp) => {
    if (!timestamp) return 'NA';

    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedUsers = [...users].sort((a, b) => {
      if (!a[key] || !b[key]) return 0;
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return direction === 'asc' ? -1 : 1;
      }
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    setUsers(sortedUsers);
  };

  return (
    <>
      {loading && <div className="loader"><div className="spinner"></div></div>}
      {error && <p className="error-message">{error}</p>}

      <div className={`${location.pathname.includes('user-management') ? 'RightSideDiv' : ''} ${loading ? 'blurred' : ''}`}>
        <div className="car-care-tips">
          <div className="right-top">
            <div className="d-flex gap-3 justify-content-end">
              <input
                type="text"
                className="search-input"
                placeholder="Search . . ."
                value={query}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div className="table-outer">
            <table className="table">
              <thead>
                <tr className="t-heading">
                  <th className="sr-no"><h5>No</h5></th>
                  {/* <th className="profile-image"><h5>Profile</h5></th> */}
                  <th className="order" onClick={() => handleSort('name')}>
                    <h5>Name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}</h5>
                  </th>
                  <th className="order" onClick={() => handleSort('first_name')}>
                    <h5>User Name {sortConfig.key === 'first_name' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}</h5>
                  </th>
                  <th className="info" onClick={() => handleSort('email')}>
                    <h5>User Email {sortConfig.key === 'email' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}</h5>
                  </th>
                  <th className="order" onClick={() => handleSortDate('createdAt')}>
        <h5>Joined On {sortConfig.key === 'createdAt' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}</h5>
      </th>
                  {location.pathname.includes('user-management') && (
                    <th className="order-status"><h5>Action</h5></th>
                  )}
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((user, index) => (
                    <tr className="green" key={user.id || index}>
                      <td className="sr-no">
                        <h5>{index + 1}</h5>
                      </td>
                      {/* <td className="profile-image">
                        <img
                          src={user.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                          alt="Profile"
                          className="profile-thumbnail"
                        />
                      </td> */}
                      <td className="order">
                      <span>
                        <img
                          src={user.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                          alt="Profile"
                          className="profile-thumbnail"
                        />
                        </span>
                        <h5> 
                        {user.name}
                        </h5>
                        
                      </td>
                      <td className="order">
                        <h5>{user.user_name} {user.last_name}</h5>
                      </td>
                      <td className="info">
                        <h5>{user?.email || 'N/A'}</h5>
                      </td>
                      <td className="reference">
                        <h5>{formatDate(user?.createdAt) || 'NA'}</h5>
                      </td>
                      {location.pathname.includes('user-management') && (
                        <td className="action">
                          {/* <button onClick={() => openViewModal(user)}> */}
                          <button onClick={() => navigate(`detail/${user.id}`)}>
                            <img src={window.getPublicUrl("/assets/images/view.svg")} alt="View" />
                          </button>
                          <button className="edit" onClick={() => openModal(user)}>
                            <img src={window.getPublicUrl("/assets/images/edit.svg")} alt="Edit" />
                          </button>
                          <button onClick={() => openDeleteUserModal(user)}>
                            <img src={window.getPublicUrl("/assets/images/delete.svg")} alt="Delete" />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      <div className='alert alert-danger'>No users found.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={editUserModal} onRequestClose={() => setEditUserModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay edit-user" portalClassName="add-user edit">
            <EditUserModal setEditUserModal={setEditUserModal} userDetails={selectedUserId} />
          </Modal>
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={viewUserModal} onRequestClose={() => setEditUserModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay edit-user" portalClassName="add-user edit subscription-detail">
            <ViewUser setViewUserModal={setViewUserModal} userDetails={selectedUserId} />
          </Modal>
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay add-category delete logout" portalClassName="add-user deactivate">
            <DeleteModal setDeleteModal={setDeleteModal} userDetails={selectedUserId} />
          </Modal>
        </Suspense>
      </div>
    </>
  );
};

export default UserManagement;